import { CLOSE_TICKER } from "../_actions/community-ticker.action";

const initialState = {
  isTickerClosed: false,
};

const tickerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_TICKER:
      return { ...state, isTickerClosed: true };
    default:
      return state;
  }
};

export default tickerReducer;
